import { render, staticRenderFns } from "./CookieModalForm.vue?vue&type=template&id=90658016"
import script from "./CookieModalForm.vue?vue&type=script&lang=js"
export * from "./CookieModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports